export const DEFAULT_INPUT_DATA = {
  comment: '',
  attachments: []
};
